// Module
var code = "";
// Exports
var _module_exports = code;;
var path = 'views/marketplace/marketplace-product-billing-items-common.tier.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;